<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script setup>
</script>

<style>
html,body,#app {
  height: 100%;
  margin: 0px;
  padding: 0px;
}

.subject-tree .el-tree-node__content{
  height: 40px !important;
}
.el-select__wrapper{
  width: 180px !important;
}

.container {
  margin-top: 0.5vh !important;
  padding: 0 !important;
}
.add-button{
  background: #ff6b9d;
  border: none;
}
.add-button:hover{
  background: #f888add5;
}
/* 搜索按钮样式 */
.search-button {
  background: linear-gradient(135deg, #ff6b9d 0%, #ff99cc 100%) !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(255, 107, 157, 0.3) !important;
  transition: all 0.3s ease !important;
}
.search-button:hover {
  background: linear-gradient(135deg, #ff4d94 0%, #ff80c4 100%) !important;
  color: #ffffff !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(255, 107, 157, 0.4) !important;
}
.search-button:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 6px rgba(255, 107, 157, 0.3) !important;
}
.submit-button {
  background: linear-gradient(135deg, #ec4899 0%, #f472b6 100%);
  border: none;
  border-radius: 25px;
  padding: 14px 35px;
  font-weight: 700;
  color: white;
  box-shadow: 
    0 6px 20px rgba(236, 72, 153, 0.4),
    0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.submit-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.submit-button:hover::before {
  left: 100%;
}

.submit-button:hover {
  background: linear-gradient(135deg, #db2777 0%, #ec4899 100%);
  transform: translateY(-3px) scale(1.05);
  box-shadow: 
    0 8px 25px rgba(236, 72, 153, 0.5),
    0 3px 10px rgba(0, 0, 0, 0.15);
}

.submit-button:active {
  transform: translateY(0) scale(1);
  box-shadow: 
    0 4px 12px rgba(236, 72, 153, 0.3),
    0 1px 4px rgba(0, 0, 0, 0.08);
}
/* 重置按钮样式 */
.reset-button {
  background: linear-gradient(135deg, #ffd6e7 0%, #ffb3d9 100%) !important;
  border: 1px solid #ffb3d9 !important;
  color: #ff6b9d !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 6px rgba(255, 182, 193, 0.3) !important;
  transition: all 0.3s ease !important;
}
 
.reset-button:hover {
  background: linear-gradient(135deg, #ffedf5 0%, #ffd6e7 100%) !important;
  border-color: #ff6b9d !important;
  color: #ff4d94 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 10px rgba(255, 182, 193, 0.4) !important;
}
 
.reset-button:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 4px rgba(255, 182, 193, 0.3) !important;
}
/* 粉色开关样式 */
.pink-switch {
  --el-switch-on-color: #ff6b9d;
  --el-switch-off-color: #ffd6e7;
}

.pink-switch :deep(.el-switch__core) {
  border-color: #ffb3d9;
}

.pink-switch :deep(.el-switch__action) {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(255, 107, 157, 0.3);
}

.pink-switch.is-checked :deep(.el-switch__core) {
  background-color: #ff6b9d;
  border-color: #ff6b9d;
}

.pink-switch:not(.is-checked) :deep(.el-switch__core) {
  background-color: #ffd6e7;
  border-color: #ffb3d9;
}

.pink-switch:hover :deep(.el-switch__core) {
  border-color: #ff6b9d;
}
/* 弹窗样式 */
.clazz-dialog {
  --el-dialog-bg-color: linear-gradient(145deg, rgba(255, 255, 255, 0.98) 0%, rgba(253, 242, 248, 0.95) 100%);
  --el-dialog-box-shadow: 0 25px 80px rgba(236, 72, 153, 0.35);
  padding: 0px !important;
  border-radius: 20px;
  overflow: hidden;
}

.clazz-dialog .el-dialog {
  border-radius: 30px;
  overflow: hidden;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98) 0%, rgba(252, 231, 243, 0.9) 100%);
  backdrop-filter: blur(25px);
  border: 2px solid rgba(251, 207, 232, 0.8);
  box-shadow: 
    0 25px 80px rgba(236, 72, 153, 0.4),
    0 8px 30px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.clazz-dialog .el-dialog__header {
  background: linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%);
  border-bottom: 1px solid rgba(251, 207, 232, 0.6);
  margin: 0;
  padding: 25px 35px;
  position: relative;
  overflow: hidden;
}

.clazz-dialog .el-dialog__header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #ec489a3a, #f472b6, #f9a8d4, #fbcfe8);
}

.clazz-dialog .el-dialog__title {
  color: #831843;
  font-size: 20px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(131, 24, 67, 0.1);
}

.clazz-dialog .el-dialog__headerbtn {
  top: 25px;
  right: 25px;
  background: rgba(236, 72, 153, 0.1);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.clazz-dialog .el-dialog__headerbtn:hover {
  background: rgba(236, 72, 153, 0.2);
  transform: scale(1.1);
}

.clazz-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #ec4899;
  font-size: 18px;
  font-weight: bold;
}

.clazz-dialog .el-dialog__title {
  color: #ec4899;
  font-weight: 600;
}

.clazz-dialog .el-dialog__body {
  padding: 35px;
  background: linear-gradient(145deg, rgba(253, 242, 248, 0.8) 0%, rgba(252, 231, 243, 0.7) 100%);
}
/* 弹窗底部按钮 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
  padding-top: 25px;
  border-top: 1px solid rgba(251, 207, 232, 0.6);
  position: relative;
}

.dialog-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(251, 207, 232, 0.9), transparent);
}

</style>